module.exports = __webpack_public_path__ + "img/belgium.382e446b.svg";